import {Component, OnInit} from '@angular/core';
import {filenameDateFormat, WizardUtils} from "../../shared/WizardHelpers";
import {DialogRef} from "@fundamental-ngx/core/dialog";
import {PdfService} from "../../../../../service/services/misc/pdf/pdf.service";
import {DialogService} from "../../../../../service/services/misc/dialog/dialog.service";
import {
    ConfirmationDialogComponent,
    ConfirmationDialogConfig
} from "../../../../../shared/dialogs/confirmation-dialog/confirmation-dialog.component";
import {firstValueFrom} from "rxjs";
import {formatDate} from "@angular/common";

@Component({
    selector: 'app-unified-download-finished-dialog',
    templateUrl: './unified-download-finished-dialog.component.html',
    styleUrls: ['./unified-download-finished-dialog.component.scss'],
    standalone: false
})
export class UnifiedDownloadFinishedDialogComponent implements OnInit {
    res: any;
    payload: any;
    numberOfParameterIssues = 0;
    downloadReport = true;

    constructor(private _dialogRef: DialogRef, private _pdfService: PdfService, private _dialogService: DialogService) {
    }

    ngOnInit() {
        this.res = this._dialogRef.data.res;
        this.payload = this._dialogRef.data.payload;
        if (this.res?.serviceInstanceParametersReport?.length > 0) {
            this.numberOfParameterIssues = WizardUtils.calculateNumberOfParameterIssues(this.res.serviceInstanceParametersReport);
        }
    }

    async onClose() {
        if (this.downloadReport && this.numberOfParameterIssues) {
            await this.downloadParametersReport(this.res.serviceInstanceParametersReport);
        }
    }

    async downloadParametersReport(serviceInstanceParametersReport: any) {
        const parametersReportDefinition = WizardUtils.generateParametersReportDefinition(serviceInstanceParametersReport,
            undefined, undefined);
        const parametersReport = await this._pdfService.generatePdf(parametersReportDefinition);
        const formattedDate = formatDate(new Date(), filenameDateFormat, 'en-US');
        this._pdfService.downloadPdf(parametersReport, `${this.payload.managedServiceName}-parameters-report_${formattedDate}.pdf`);
    }

    async onDownloadReportChange() {
        if (this.downloadReport || !this.res?.serviceInstanceParametersReport?.length) {
            return;
        }

        // set 'downloadReport' back to 'true' so that checkbox is unchecked
        this.downloadReport = true;

        const confirmationDialogConfig = new ConfirmationDialogConfig({
            title: "Confirm PDF Download",
            bodyText: "Are you sure you want to skip the download of the parameter issues report for the AutomationSolution configuration? <br/><br/> Note that the list of the detected issues won't be available anywhere after you close this dialog. You'll need to use the Cloud Automation Designer to address these issues directly in the AutomationSolution after it is generated for your solution to be complete. ",
            cancelText: "Keep the PDF",
            confirmText: "Yes, Skip the PDF"
        });

        const dialogRef = this._dialogService.openDialog(ConfirmationDialogComponent, confirmationDialogConfig, undefined, "25rem");
        try {
            await firstValueFrom(dialogRef.afterClosed);
            // if user confirms, set 'downloadReport' to 'false' so that checkbox is unchecked
            this.downloadReport = false;
        } catch {
            return;
        }
    }
}
